export class ListItem<T extends string = string>  {

    id: T;
    name: string;
    fk:string|undefined = undefined;
    displayOrder: number = 0;

    constructor(item: Partial<ListItem<T>>) {
        if (item.id == null)
            throw new Error(`Invalid list item in constructor: ${JSON.stringify(item)}
                id cannot be null`);
        if (item.name == null)
            throw new Error(`Invalid list item in constructor: ${JSON.stringify(item)}
                name cannot be null`);
    
        if (item.displayOrder == null) {
            this.displayOrder = 0;
        }
        else {
            this.displayOrder = item.displayOrder;
        }

        this.id = item.id;
        this.name = item.name;
        this.fk = item.fk;
    }

    static createEmpty(): Partial<ListItem> {
        return new ListItem({
            id: "",
            name: "",
            fk: "",
        });
    }

/*
    constructor(
        public name: string,
        public value: string
    ) {}

    public createEmpty() {
        return new ListItem("", "");
    }
*/
}
